import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ChatPrompt from "./ChatPrompt";
import ChatSurvey from './chatSurvey';
import { IoMenu } from "react-icons/io5";
import { useSelector, useDispatch } from 'react-redux';
import { userInfo } from "../../redux/Selectors/selectors";
import { selectbackground } from "../../redux/Slices/toggleBackgroundSlice";
import { getUserChatFromAPIAsync, postUserNeed } from "../../redux/Thunks/chatBotThunk";
import { addOne, selectRenderedState, surveyActivity, toggleChatSideBar } from '../../redux/Slices/sharedUseEffectSlice';
import { generateSurvey } from '../../redux/Thunks/chatBotThunk';
import Alert from "../common/Alert";
import { simulateStreaming } from '../common/checks_Func';
import Conversations from './Conversations';
import { toast } from 'react-toastify';
import { clearStreamedData, streamedResult } from '../../redux/Slices/chatBotSlice';

const ChatBoxByTranscript = ({sidebarOpen}) => {
    const divRef = useRef(null);
    const streamingIntervalRef = useRef(null);
    const isMountedRef = useRef(true); // Add mounted ref
    const isSurveyTime = useSelector(state => state.shared_useEffect.isFive);
    const surveyCarriedOut = useSelector(state => surveyActivity(state))
    const location = useLocation()
    const streamingDispatchResult = useSelector(streamedResult)
    // eslint-disable-next-line
    const [connectionStatus,setConnectionStatus] = useState("")

    let userID;
    const userDetails = useSelector(userInfo);
    if (userDetails) {
        userID = userDetails.id;
    }

    const { transcriptID } = useParams(); 
    const dispatch = useDispatch();
    const currentMode = useSelector(state => selectbackground(state)); // Light and Dark Mode
    const isRendered = useSelector(state => selectRenderedState(state));

    const [userPrompt, setUserPrompt] = useState("")
    const [simulatedPrompt, setSimulatedPrompt] = useState("")
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMsg, setErrorMsg] = useState("Oops! Something went wrong.");
    const [successFeedBack, setSuccessFeedBack] = useState({
        message: "",
        link : ""
    })
    const [userChats, setUserChats] =  useState([])
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [streamingResponse, setStreamingResponse] = useState("")
    const [isActiveStreaming, setIsActiveStreaming] = useState(false)

 
    const scrollToBottom = () => {
        if (divRef.current && isMountedRef.current) {
            divRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    };

    async function timeoutAlert() {
        if (showError || showSuccess) {
            // Set a timeout to hide the error alert after 8 seconds
            const timeout = setTimeout(() => {
                if (isMountedRef.current) {
                    setShowError(false);
                    setShowSuccess(false);
                }
            }, 7000);

            // Clear the timeout if the component unmounts or if showError changes
            return () => clearTimeout(timeout);
        }
    }

    async function fetchData() {
        if (!isMountedRef.current) return
        
        dispatch(clearStreamedData())
        setSimulatedPrompt("")
        setStreamingResponse("") 
        setIsActiveStreaming(false)
        
        if (isRendered && userDetails) {
            try {
                const data = await dispatch(
                    getUserChatFromAPIAsync({
                        transcript_id: transcriptID
                    })
                ).unwrap()
                
                if (isMountedRef.current) { 
                    setUserChats(Array.isArray(data) ? data : [])
                    scrollToBottom()
                    
                    const timer = setTimeout(() => {
                        if (isMountedRef.current) {
                            setIsPopupOpen(true)
                        }
                    }, 3000); // 3 seconds
                    return () => clearTimeout(timer);
                }
            } catch (error) {
                console.error('Error fetching chat data:', error);
            }
        }
    }

    const handleClosePopup = (msg, link) => {
        setSuccessFeedBack({
            message: msg,
            link : link
        })
        setIsPopupOpen(false);
        setShowSuccess(true)
    };

    const handleError = () => {
        toast.error(errorMsg)
        setShowError(true)
    };

    const toggleNavbar = () => {
        dispatch(toggleChatSideBar());
    };

    const handleClick = async (e) => {
        e.preventDefault()
        setStreamingResponse("") 
        setIsActiveStreaming(true)
        setSimulatedPrompt(userPrompt)

       const question = userPrompt
        setUserPrompt("")

        if (userDetails) {
            dispatch( addOne({ isFive: isSurveyTime + 1}))

            try {
                // DISPATCH THE USER PROMPT
                dispatch(
                    postUserNeed({
                    prompt: question,
                    transcript_id : transcriptID,
                    })
                )
                
            } catch (error) {
                setUserPrompt(simulatedPrompt)
                setShowError(true);
                setStreamingResponse("")
                setIsActiveStreaming(false)
            }
        } else {
            setUserPrompt(simulatedPrompt)
            setErrorMsg("Ooops, you are not logged in.");
            setShowError(true);
            setStreamingResponse("")
            setIsActiveStreaming(false)
        }

    };


    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        dispatch(clearStreamedData())
        setStreamingResponse("") 
        timeoutAlert();
        // eslint-disable-next-line
    }, [showError, showSuccess, isRendered]);

    useEffect(() => {
         fetchData()
        if (location.state?.prompt) {
            setIsActiveStreaming(true)
            setSimulatedPrompt(location.state?.prompt)
        }else{
            setIsActiveStreaming(false)
        }
     //eslint-disable-next-line
    },[userDetails, transcriptID])



    useEffect(() => {
        const unFilteredURL = `wss://${process.env.REACT_APP_SERVER_URL}/ws/create-messages/${userID}/`;
        let wsUrl = unFilteredURL.replace("https://", "")
    
        if(process.env.REACT_APP_ENV === "development"){
            wsUrl = `ws://localhost:8000/ws/create-messages/${userID}/`;
        }
    
        const ws = new WebSocket(wsUrl);
    
        ws.onopen = () => {
          console.log('WebSocket Connected');
          setConnectionStatus('connected');
        };
    
        ws.onmessage = (e) => {
          try {
            const data = JSON.parse(e.data);

            if(data.type === "chat_generated"){
                simulateStreaming(streamingIntervalRef, data?.ai_response, (streamedText, isStreamingComplete) => {
                    if (!isMountedRef.current) return; // Check if mounted
                    
                    if(!isStreamingComplete){
                        setStreamingResponse(streamedText)
                        scrollToBottom()
                    }else{
                        setIsActiveStreaming(false)
                        fetchData()
                        scrollToBottom()
                        setStreamingResponse("")         
                        // IF THE USER CHATS GOT A RESPONSE, CHECK IF SURVEY HAS BEEN CARRIED OUT
                        // AND IF THE SURVEY NUMBER IS GREATER THAN 1
                        // IF SO, GENERATE A SURVEY AFTER 2 SECONDS
                        setTimeout(() => {
                            if (isMountedRef.current && isSurveyTime >= 2 && !surveyCarriedOut) {
                                dispatch(
                                    generateSurvey({
                                        user_id: userID,
                                        transcript_id: transcriptID
                                    })
                                ).unwrap();
                            }
                        }, 2000);
                    }
                })   
            }
    
          } catch (err) {
            console.error('Error parsing message:', err);
          }
        };
    
        ws.onclose = (e) => {
          console.log('Chat WebSocket Closed', e);
          setConnectionStatus('disconnected')
          setErrorMsg("Connection was timed out.")
        };
    
        ws.onerror = (e) => {
          console.error('Chat WebSocket Error', e);
          setConnectionStatus('error')
          setErrorMsg("Network Error, connection timed out.")
        };
    
        // Cleanup function
        return () => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.close();
          }
        };
    
      // eslint-disable-next-line
    }, [userID])


    useEffect(() => {
        if (!isMountedRef.current) return
        
        if (streamingDispatchResult?.user_response) {
            setSimulatedPrompt(streamingDispatchResult.user_response)
        }
            
        if(streamingDispatchResult?.type === "chat_generated"){
            try {
                setIsActiveStreaming(true)
                simulateStreaming(streamingIntervalRef, streamingDispatchResult?.ai_response, (streamedText, isStreamingComplete) => {
                    if (!isMountedRef.current) return
                    
                    if(!isStreamingComplete){  
                        setStreamingResponse(streamedText) 
                    }else{
                        setIsActiveStreaming(false)
                        fetchData()
                        scrollToBottom()
                    }
                })
            } catch (error) {
                setIsActiveStreaming(false)
            }
        }
        //eslint-disable-next-line
    }, [streamingDispatchResult])


    useEffect(() => {
        scrollToBottom()
    }, [userChats, streamingResponse]);

    return (
        <div className={`w-full lg:w-4/5 relative h-screen ${sidebarOpen && "blur-sm lg:blur-none"}
        ${!currentMode ? `bg-white text-black` : `bg-nightModeDark text-white`} `}>

            <div className='relative overflow-y-scroll no-scrollbar
            h-screen px-3 sm:px-5 pb-[70px]'>

            <div className={`sticky top-0 z-10 w-full flex justify-between
             ${!currentMode ? `bg-white text-black`
             : `bg-nightModeDark text-white`}`} >

            <button
                className="lg:hidden m-2.5 text-2xl"
                onClick={toggleNavbar}>
                <IoMenu
                className={`${currentMode ?
                "text-chatTipBackground" : "text-nightModeDark"}`} />
            </button>

                    {/* <div className='flex justify-end sm:w-full'>
                    <button
                className="m-2.5 text-2xl lg:text-4xl"
                onClick={handleBackgroundChange}>
                {currentMode ? <LiaToggleOnSolid /> : <LiaToggleOffSolid />}
            </button>
                    </div> */}

            </div>

                {userChats && userChats?.map(({ user_response, ai_response }, idx) => {
                    return <div key={idx}>
                                <Conversations 
                                userDetails={userDetails}
                                userprompt={user_response}
                                ai_response={ai_response}
                                streamResponse={false}
                                />
                            </div>
                })}

                {(simulatedPrompt && isActiveStreaming) 
                    ? <Conversations userprompt={simulatedPrompt} 
                                    ai_response={streamingResponse} 
                                    userDetails={userDetails} 
                                    streamResponse={isActiveStreaming} />
                    : null
                }
                <div ref={divRef} className="pt-[50px]" />

                

            </div>

            {showError && <Alert
                isVisible={showError}
                message={errorMsg}
                type="error"
            />}
            {showSuccess && <Alert
                isVisible={showSuccess}
                link={successFeedBack?.link}
                message={successFeedBack?.message}
                type="success"
            />}

            {userChats.length > 0 && <ChatPrompt
                currentMode={currentMode}
                bgOnDark="bg-nightModeDark"
                placeholder="Hi, Let's talk policies today!"
                position="sticky"
                submitPrompt={handleClick}
                value={userPrompt}
                handleChange={e => setUserPrompt(e.target.value)} />
            }

            <ChatSurvey
                onError={handleError}
                isOpen={isPopupOpen}
                transcript_id={transcriptID}
                onClose={handleClosePopup}
            />

        </div>
    );
}

export default ChatBoxByTranscript;